module.exports = __webpack_public_path__ + "static/media/RD_LD.46ef2f0d.webp";